import type { Announcement } from '@/lib/api';

/** 運営からのお知らせ。表示期間内のものだけが API から返る。 */
export function AnnouncementBanner({ announcements }: { announcements: Announcement[] }) {
  if (announcements.length === 0) return null;

  return (
    <div className="flex flex-col border-b border-line-strong bg-brand-50">
      {announcements.map((announcement) => (
        /*
         * 狭い幅では本文が数行に折り返す。そのとき `items-center` だと NOTICE の
         * ラベルが本文の中ほどに浮くので、無印は上端に揃える (768px 以上は現状のまま)。
         */
        <div
          key={announcement.id}
          className="flex items-start gap-3 px-4 py-2.5 md:items-center md:px-8"
        >
          <span className="font-mono text-[10px] tracking-wider text-brand-700">NOTICE</span>
          <span className="text-[13px] text-ink-secondary">{announcement.message}</span>
        </div>
      ))}
    </div>
  );
}
